import { get, post, del } from '@core/api/client';
import { endpoints } from '@core/api/endpoints';

export interface PlatformUser {
  id: string;
  email: string;
  fullName: string | null;
  isActive: boolean;
  status: string;
  platformRoles: { roleId: string; roleName: string }[];
  createdAt: string;
}

export interface TenantUser {
  membershipId: string;
  userId: string;
  email: string;
  fullName: string | null;
  isActive: boolean;
  membershipStatus: string;
  roleId: string;
  roleName: string;
  createdAt: string;
}

export const usersService = {
  listPlatform(): Promise<PlatformUser[]> {
    return get(endpoints.platformUsers.list);
  },

  disablePlatform(userId: string): Promise<void> {
    return post(endpoints.platformUsers.disable(userId));
  },

  enablePlatform(userId: string): Promise<void> {
    return post(endpoints.platformUsers.enable(userId));
  },

  listTenant(): Promise<TenantUser[]> {
    return get(endpoints.tenantUsers.list);
  },

  disableTenantMembership(membershipId: string): Promise<void> {
    return post(endpoints.tenantUsers.disable(membershipId));
  },

  enableTenantMembership(membershipId: string): Promise<void> {
    return post(endpoints.tenantUsers.enable(membershipId));
  },

  removeTenantMembership(membershipId: string): Promise<void> {
    return del(endpoints.tenantUsers.remove(membershipId));
  },

  resetPlatformMfa(userId: string): Promise<void> {
    return post(endpoints.platformUsers.resetMfa(userId));
  },

  resetTenantMfa(userId: string): Promise<void> {
    return post(endpoints.tenantUsers.resetMfa(userId));
  },
};
